const moment = require('@transfeeradev/moment');
const { banks } = require('@transfeeradev/api-enums');

class TEDHourService {
  constructor(bankCode) {
    this._bankCode = bankCode;
  }

  isValid() {
    const current = moment();
    let start = moment('07:00:00', 'HH:mm:ss');
    let end = moment('16:30:00', 'HH:mm:ss');

    if (this._bankCode === banks.SANTANDER.code) {
      end = moment('16:25:59', 'HH:mm:ss');
    }

    if (this._bankCode === banks.TOPAZIO.code) {
      start = moment('7:15:00', 'HH:mm:ss');
      end = moment('16:25:59', 'HH:mm:ss');
    }

    if (this._bankCode === banks.NEON.code) {
      start = moment('07:30:00', 'HH:mm:ss');
      end = moment('15:55:00', 'HH:mm:ss');
    }

    if (this._bankCode === banks.ABC_BRASIL.code) {
      start = moment('07:30:00', 'HH:mm:ss');
      end = moment('16:55:00', 'HH:mm:ss');
    }

    if (this._bankCode === banks.STONE.code) {
      start = moment('07:00:00', 'HH:mm:ss');
      end = moment('17:15:00', 'HH:mm:ss');
    }

    // '[]' [] indicates inclusion of a value. i.e. IsSameOrBetween
    return current.isBetween(start, end, null, '[]');
  }
}

module.exports = TEDHourService;
